import { auth, formData } from '../constants/actions'
import { generateRandomString } from '../utils/common'

const basicInfo = {
  sfid: null,
  isNewMember: true,
  isInformationCompleted: false,
  memberProfileId: null,
  firstname: '',
  lastname: '',
  birthdate: '',
  gender: '',
  genderIdentity: '',
  genderIdentityOther: '',
  email: '',
  mobile: '',
  memberTypes: [],
  photo: '',
  products: [],
  questions: {},
}

const initialState = {
  registrations: {},
  currentRegistration: null,
  orderId: null,
  registrationData: {},
  sessions: {},
  sessionId: null,
  initialPaymentGateway: null,
  team: {
    isTeamReset: true,
    defaultQuestions: {},
    teamDetails: {},
    teamProducts: [],
    teamAddOn: [],
    teamQuestions: {},
    teamSubEventProducts: {},
    teamCode: null,
  },
}

export default (state = initialState, action) => {
  switch (action.type) {
    case formData.SELECT_PARTICIPANT: {
      const newRegistrations = { ...state.registrations }
      let currentRegistration = null
      if (action.payload === null) {
        currentRegistration = generateRandomString(18)
        newRegistrations[currentRegistration] = {
          ...basicInfo,
          sfid: currentRegistration,
        }

        return {
          ...state,
          currentRegistration,
          registrations: newRegistrations,
        }
      }

      const { sfid, isNewMember } = action.payload
      currentRegistration = sfid
      newRegistrations[sfid] = {
        ...basicInfo,
        ...(state.registrations[sfid] ? state.registrations[sfid] : action.payload),
        isNewMember: !!isNewMember,
      }

      return {
        ...state,
        currentRegistration,
        registrations: newRegistrations,
      }
    }
    case formData.CLEAR_PARTICIPANT: {
      const newRegistrations = { ...state.registrations }
      delete newRegistrations[action.payload]
      return {
        ...state,
        currentRegistration: null,
        registrations: newRegistrations,
      }
    }
    case formData.SET_VALUES: {
      const newRegistrations = { ...state.registrations }
      const currentRego = newRegistrations[state.currentRegistration]
      newRegistrations[state.currentRegistration] = {
        ...currentRego,
        ...action.payload,
      }

      return {
        ...state,
        registrations: newRegistrations,
      }
    }
    case formData.SET_TEAM_VALUES: {
      return {
        ...state,
        team: {
          ...state.team,
          ...action.payload,
        },
      }
    }
    case formData.SET_CURRENT_REGISTRATION: {
      const regId = action.payload
      if (regId && state.registrations[regId]) {
        const newRegistrations = { ...state.registrations }
        newRegistrations[regId] = {
          ...basicInfo,
          ...state.registrations[regId],
        }
        return {
          ...state,
          currentRegistration: regId,
          registrations: newRegistrations,
        }
      }
      return {
        ...state,
        currentRegistration: action.payload || null,
      }
    }
    case formData.SET_SESSIONS: {
      return {
        ...state,
        sessions: action.payload || null,
      }
    }
    case formData.SET_REGISTRATION_DATA: {
      return {
        ...state,
        registrationData: action.payload || null,
      }
    }
    case formData.SET_ORDER_ID: {
      return {
        ...state,
        orderId: action.payload || null,
      }
    }
    case formData.REMOVE_MEMBER: {
      const newRegistrations = { ...state.registrations }
      delete newRegistrations[action.payload]
      return {
        ...state,
        registrations: newRegistrations,
        currentRegistration: action.payload === state.currentRegistration ? null : state.currentRegistration,
      }
    }
    case formData.RESET_FORM: {
      return {
        ...initialState,
        email: state.email,
        userid: state.userid,
        userName: state.userName,
      }
    }
    case formData.REMOVE_MEMBER_ITEMS: {
      const newRegistrations = { ...state.registrations }

      action.payload.forEach(item => {
        const { summaryId, itemId } = item
        const newRegistration = {
          ...newRegistrations[summaryId],
        }

        const newProds = {
          ...newRegistration.newProducts,
        }

        const newSubEventProds = {
          ...newRegistration.newSubEventProducts,
        }

        const newAddOnProducts = {
          ...newRegistration.newAddOnProducts,
        }

        delete newProds[itemId]
        delete newSubEventProds[itemId]
        delete newAddOnProducts[itemId]

        newRegistration.newProducts = newProds
        newRegistration.newSubEventProducts = newSubEventProds
        newRegistration.newAddOnProducts = newAddOnProducts
        newRegistrations[summaryId] = newRegistration
      })

      return { ...state, registrations: newRegistrations }
    }
    case formData.REMOVE_TEAM:
      return {
        ...state,
        team: initialState.team,
      }
    case formData.REMOVE_TEAM_ITEMS: {
      // eslint-disable-next-line no-case-declarations
      const newTeam = { ...state.team }

      action.payload.forEach(p => {
        const { itemId } = p
        const newTeamProducts = {
          ...newTeam.teamProducts,
        }

        const newTeamSubEventProducts = {
          ...newTeam.teamSubEventProducts,
        }

        const newTeamAddOn = {
          ...newTeam.teamAddOn,
        }

        delete newTeamProducts[itemId]
        delete newTeamSubEventProducts[itemId]
        delete newTeamAddOn[itemId]

        newTeam.teamProducts = newTeamProducts
        newTeam.teamSubEventProducts = newTeamSubEventProducts
        newTeam.teamAddOn = newTeamAddOn
      })

      return {
        ...state,
        team: newTeam,
      }
    }
    case formData.SET_SESSION_ID:
      return {
        ...state,
        sessionId: action.payload,
      }
    case formData.SET_INITIAL_PAYMENT_GATEWAY:
      return {
        ...state,
        initialPaymentGateway: action.payload,
      }
    case auth.SIGN_OUT: {
      return initialState
    }
    case formData.SET_TEAM_CODE: {
      return {
        ...state,
        team: {
          ...state.team,
          teamCode: action.payload || null,
        },
      }
    }
    default:
      return state
  }
}
